<template>
  <article class="ut-documento-detalle">
    <header class="ut-documento-cabecera">
      <div class="ut-documento-identidad"><span>{{ vista === 'tickets' ? 'Ticket' : 'Envio' }}</span><h2>{{ modelo.numero }}</h2></div>
      <strong class="ut-documento-estado" :class="{ 'ut-documento-cancelado': modelo.cancelado }">{{ modelo.estado }}</strong>
      <p v-if="modelo.ruta" class="ut-documento-ruta"><span>Ruta</span> {{ modelo.ruta }}</p>
    </header>
    <section v-for="grupo in modelo.grupos" :key="grupo.titulo" class="ut-documento-seccion">
      <h3>{{ grupo.titulo }}</h3>
      <p v-if="grupo.vacio" class="ut-documento-vacio">{{ grupo.vacio }}</p>
      <dl v-else class="ut-documento-datos">
        <div v-for="campo in grupo.campos" :key="campo.titulo" :class="{ 'ut-documento-ancho': campo.ancho }"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div>
      </dl>
    </section>
    <footer class="ut-documento-importes">
      <dl class="ut-documento-notas"><div v-for="campo in modelo.notas" :key="campo.titulo"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div></dl>
      <dl class="ut-documento-totales"><div v-for="campo in modelo.totales" :key="campo.titulo"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div><div class="ut-documento-total"><dt>Total</dt><dd>{{ modelo.total }}</dd></div></dl>
    </footer>
  </article>
</template>

<script>
import { detalleVenta } from './detalleVenta';
export default {
  name: 'DetalleVentaTransporte',
  props: { datos: { type: Object, required: true }, vista: { type: String, required: true } },
  computed: { modelo() { return detalleVenta(this.vista, this.datos); } },
};
</script>

<style scoped>
.ut-documento-detalle { color: #243746; background: #fff; font-size: 14px; line-height: 1.45; letter-spacing: 0; }
.ut-documento-detalle * { box-sizing: border-box; letter-spacing: 0; }
.ut-documento-cabecera { display: flex; align-items: center; justify-content: space-between; gap: 12px 24px; flex-wrap: wrap; padding: 16px 24px; background: #e8f1f7; }
.ut-documento-identidad { min-width: 0; flex: 1 1 280px; }
.ut-documento-identidad > span, .ut-documento-ruta > span { color: #526879; font-size: 12px; }
.ut-documento-identidad h2 { font-size: 24px; font-weight: 700; line-height: 1.3; margin: 0; color: #28618a; overflow-wrap: anywhere; }
.ut-documento-estado { font-size: 12px; color: #28604d; overflow-wrap: anywhere; }
.ut-documento-cancelado { color: #a02d35; }
.ut-documento-ruta { flex-basis: 100%; margin: 0; font-weight: 600; overflow-wrap: anywhere; }
.ut-documento-ruta > span { margin-right: 8px; font-weight: 400; }
.ut-documento-seccion h3 { margin: 0; padding: 8px 24px; border-top: 1px solid #cddde8; border-bottom: 1px solid #cddde8; background: #eff5f9; font-size: 14px; font-weight: 700; }
.ut-documento-datos { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 28px; padding: 14px 24px 18px; margin: 0; }
.ut-documento-detalle dt { font-size: 12px; color: #526879; }
.ut-documento-detalle dd { margin: 2px 0 0; font-weight: 600; overflow-wrap: anywhere; white-space: pre-wrap; }
.ut-documento-ancho { grid-column: 1 / -1; }
.ut-documento-vacio { padding: 14px 24px; margin: 0; color: #526879; }
.ut-documento-importes { display: grid; grid-template-columns: minmax(0, 1fr) minmax(250px, 310px); gap: 24px; padding: 16px 24px; border-top: 1px solid #d5dce1; }
.ut-documento-notas, .ut-documento-totales { margin: 0; min-width: 0; }
.ut-documento-notas > div + div { margin-top: 12px; }
.ut-documento-totales > div { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; padding: 3px 0; }
.ut-documento-totales dd { text-align: right; font-variant-numeric: tabular-nums; }
.ut-documento-totales .ut-documento-total { margin-top: 8px; padding-top: 10px; border-top: 1px solid #c8d5de; font-size: 18px; }
.ut-documento-total dt { font-size: 16px; color: #243746; font-weight: 700; }
@media (max-width: 560px) {
  .ut-documento-cabecera, .ut-documento-datos, .ut-documento-importes { padding: 14px 16px; }
  .ut-documento-seccion h3 { padding: 8px 16px; }
  .ut-documento-datos, .ut-documento-importes { grid-template-columns: minmax(0, 1fr); }
  .ut-documento-identidad { flex-basis: 100%; }
}
</style>
